import React from "react";
import MuiPaper from "@mui/material/Paper";
import PropTypes from "prop-types";

/**
 * Paper component wrapper for surfaces and containers.
 * Wraps Material-UI Paper with theme integration.
 * 
 * @component
 * @example
 * <Paper elevation={3}>
 *   <Typography>Content</Typography>
 * </Paper>
 */
const Paper = React.forwardRef(({ children, ...props }, ref) => {
  return <MuiPaper ref={ref} {...props}>{children}</MuiPaper>;
});

Paper.displayName = 'Paper';

Paper.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.node,
  /**
   * The component used for the root node
   */
  component: PropTypes.elementType,
  /**
   * Shadow depth, corresponds to dp in the spec
   */
  elevation: PropTypes.number,
  /**
   * If true, rounded corners are disabled
   */
  square: PropTypes.bool,
  /**
   * The variant to use
   */
  variant: PropTypes.oneOf(["elevation", "outlined"]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

// No defaultProps - maintain exact MUI Paper behavior
// MUI Paper defaults: elevation=1, square=false, variant="elevation"

export default Paper;

